import Link from 'components/ui/Link';
import config from 'config';
import { useTranslation } from 'hooks/useTranslation';
import styles from './Tags.module.scss';
import type { BlogTag } from 'types/Blog';

type Props = {
  headline?: string | undefined;
  showHeadline?: boolean;
  tags?: BlogTag[] | undefined;
};

const Tags = ({
  headline = undefined,
  showHeadline = true,
  tags,
}: Props): JSX.Element | null => {
  const { locale } = useTranslation();

  if (!tags) {
    return null;
  }

  return (
    <div className={showHeadline ? styles.container : ''}>
      {showHeadline && <h4>{headline}</h4>}
      <div className={styles.tagList}>
        {tags.slice(0, config.defaults.tagsCount).map((tag, i) => {
          if (
            tag.__typename === 'Tag' ||
            // eslint-disable-next-line
            // @ts-ignore
            tag.sys.contentType.sys.id === 'tag'
          ) {
            // eslint-disable-next-line
            // @ts-ignore
            const { name, slug } = tag.fields || tag;

            return (
              <Link key={i} href={`/${locale}/blog/tag/${slug}`}>
                <a title={name}>{name}</a>
              </Link>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default Tags;
